import React from 'react'
import './PhotoLiner.css'
import SafeArea from '../safe-area'

interface Props {
    title: string
    color: string
    customClass?: string
    hovered?: boolean
    absolute?: boolean
    safe?: boolean
    onHoverChange?: (isHovered: boolean) => void
    onHover?: () => void
    onLeave?: () => void
}

const PhotoLinerV2: React.FC<Props> = ({
    title,
    color,
    customClass = 'cormorant fs12 up',
    hovered = false,
    absolute = false,
    safe = true,

    onHoverChange,
    onHover,
    onLeave,
}) => {
    const handleEnter = () => {
        onHover?.()
        onHoverChange?.(true)
    }

    const handleLeave = () => {
        onLeave?.()
        onHoverChange?.(false)
    }

    const rootClass = `pointer fit ${hovered ? 'is-hovered' : 'liner-v2'} ${absolute ? 'is-absolute' : ''}`

    const Content = (
        <div className="d-flex aic">
            <div className="bullet-point" style={{ borderColor: color }} />
            <div className={customClass} style={{ color }}>
                {title}
            </div>
        </div>
    )

    return (
        <div className={rootClass} onMouseEnter={handleEnter} onMouseLeave={handleLeave}>
            {safe ? <SafeArea>{Content}</SafeArea> : Content}
        </div>
    )
}

export default PhotoLinerV2
